// Getters (GET*)
export const LIST_REPORTS = 'LIST_REPORTS';
export const GET_PERIOD = 'GET_PERIOD';

// Mutations (SET*, ADD*, REMOVE*)
// [CONTEXT]_[ACTION]_[PROPERTY]
export const UPDATE_LIST_REPORTS = 'UPDATE_LIST_REPORTS';
export const UPDATE_LOADING_REPORTS = 'UPDATE_LOADING_REPORTS';

// Actions (FETCH*, CREATE*, UPDATE*, DELETE*)
// [CONTEXT]_[ACTION]_[PROPERTY]_[STATUS]
export const GET_LIST_REPORTS = 'GET_LIST_REPORTS';
